const LiqurMass = [
  {
    id: 1,
    title: 'Бейліс Оріджинал (Ірландія) 1л',
    price: '2400 грн',
    src: require('../img/bail.webp'),
    text: '50мл - 120 грн',
  },
  {
    id: 2,
    title: 'Марі Брізар в асортименті (Франція) 0,7л',
    price: '980 грн',
    src: require('../img/mbl.webp'),
    text: '50мл - 70грн',
  },
  {
    id: 3,
    title: 'Воларе в асортименті (Італія) 0,7л',
    price: '980 грн',
    src: require('../img/volare.webp'),
    text: '50мл - 70грн',
  },
  {
    id: 4,
    title: 'Самбука Антіка Классік (Італія) 0,7л',
    price: '1400 грн',
    src: require('../img/sambuka.webp'),
    text: '50мл - 100 грн',
  },
  {
    id: 5,
    title: 'Becherovka (Чехія) 1л',
    price: '2000 грн',
    src: require('../img/beherovka.png'),
    text: '50мл - 100 грн',
  },
];

export default LiqurMass;
